"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSuffixIcon = void 0;
var InputSuffixIcon;
(function (InputSuffixIcon) {
    InputSuffixIcon["success"] = "success";
    InputSuffixIcon["error"] = "error";
    InputSuffixIcon["info"] = "info";
    InputSuffixIcon["search"] = "search";
})(InputSuffixIcon = exports.InputSuffixIcon || (exports.InputSuffixIcon = {}));
